import React from 'react'

export default function UserInfoView() {
  return <div>WIP</div>
}
